export const percentageToDecimal = (percentageString: string): string => {
  if (!percentageString) {
    return '';
  }
  const numberString = percentageString.replace('%', '');
  const number = parseFloat(numberString);
  return `${number / 100}`;
};
